import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 31542 34312"
    {...props}
  >
    <defs>
      <style>{".fil0{fill:#343230}"}</style>
    </defs>
    <g id="Layer_x0020_1">
      <path
        d="M17156 23232H7184c-297 0-537-239-537-536v-7711c0-2287-589-4528-1708-6514L806 10894c-166 96-370 97-537 3-166-97-269-274-269-466V4968c0-179 89-346 238-445L6885 90c88-59 192-90 299-90h14404c104 0 208 31 296 91l6649 4432c148 99 239 266 239 445v5419c0 191-103 369-270 464-167 96-373 95-538-2l-4132-2423c-1119 1987-1709 4228-1709 6514l1 4432c0 296-241 536-536 536-296 0-536-240-536-536v-4432c0-2661 736-5264 2132-7528 154-248 477-328 729-181l3786 2220V5255l-6275-4183H7346L1072 5255v4241l3787-2221c250-147 574-67 725 182 1397 2264 2136 4867 2136 7529v7174h9436c295 0 535 239 535 536s-240 536-535 536z"
        className="fil0"
      />
      <path
        d="M14386 4951c-2434 0-4415-1980-4415-4416 0-296 240-535 536-535 297 0 537 240 537 535 0 1844 1498 3343 3342 3343 1842 0 3342-1499 3342-3343 0-296 240-535 535-535 297 0 536 240 536 535 0 2435-1979 4416-4413 4416zM16189 8846c385 251 714 582 967 968 251-386 579-717 965-968-385-251-715-581-965-967-253 386-582 716-967 967zm967 3306c-297 0-537-240-537-536 0-1232-1002-2234-2233-2234-296 0-537-240-537-536 1-296 240-536 537-536 1231-1 2233-1003 2233-2234 0-296 240-537 537-537 295 0 535 241 535 537 0 1231 1002 2234 2235 2234 295-1 535 240 535 536s-240 536-535 536c-1233 0-2235 1003-2235 2234 0 296-240 537-535 537v-1zM11203 17710c384 251 714 582 966 967 252-385 581-716 967-967-386-252-715-581-967-966-251 385-582 714-966 966zm966 3306c-296 0-535-240-535-536 0-1232-1003-2234-2235-2234-295 0-535-240-535-536 0-297 240-536 535-536 1232-1 2235-1002 2235-2234 0-297 239-536 535-536 297-1 537 239 537 536 0 1232 1001 2234 2234 2234 296-1 536 239 536 536 0 296-240 536-536 536-1232 0-2234 1002-2234 2234 0 296-241 536-537 536zM15898 33239h12487l1909-6684H13988l1910 6684zm12892 1073H15494c-240 0-451-159-517-388l-2215-7757c-46-162-14-335 86-470 102-135 261-213 429-213h17728c169 0 327 79 428 213 102 135 134 308 87 470l-2215 7756c-66 230-276 389-515 389z"
        className="fil0"
      />
      <path
        d="M17103 23232c-593 0-1074 481-1074 1073l1 106c0 591 479 1073 1072 1073h10079c591 0 1073-482 1073-1073v-106c0-592-482-1073-1073-1073H17103zm10078 3323H17103c-1184 0-2145-961-2145-2144v-106c0-1183 961-2145 2144-2145h10079c1181 0 2144 962 2144 2145l1 106c0 1183-964 2145-2145 2145v-1z"
        className="fil0"
      />
      <path
        d="M17103 19908c-593 0-1074 482-1074 1072l1 107c0 592 479 1073 1072 1073h10079c591 0 1073-481 1073-1073v-107c0-590-482-1072-1073-1072H17103zm10078 3324H17103c-1184 0-2145-962-2145-2145v-107c0-1182 961-2145 2144-2145h10079c1181 0 2144 963 2144 2145l1 107c0 1183-964 2145-2145 2145z"
        className="fil0"
      />
    </g>
  </svg>
)
export default SvgComponent
